import CityPageTemplate from "../city-template/CityPageTemplate";
import { terreHauteConfig } from "./data";

export default function TerreHautePage() {
  return <CityPageTemplate config={terreHauteConfig} />;
}